import {
  getEligiblePlansApiV1SubscriptionsEligiblePlansGet,
  getUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGet,
  initiateUpgradeApiV1SubscriptionsUpgradePost,
} from "@/backend-sdk/client/sdk.gen";
import type {
  CheckoutPaymentResponse,
  EligiblePlansResponse,
  PixQrResponse,
  UpgradeRequest,
} from "@/backend-sdk/client/types.gen";

export const fetchEligiblePlans = async (): Promise<EligiblePlansResponse> => {
  const { data } = await getEligiblePlansApiV1SubscriptionsEligiblePlansGet({
    throwOnError: true,
  });
  return data;
};

export const initiatePlanUpgrade = async (
  body: UpgradeRequest,
): Promise<CheckoutPaymentResponse> => {
  const { data } = await initiateUpgradeApiV1SubscriptionsUpgradePost({
    body,
    throwOnError: true,
  });
  return data;
};

export const fetchUpgradePixQr = async (
  invoiceId: string,
): Promise<PixQrResponse> => {
  const { data } = await getUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGet(
    {
      path: { invoice_id: invoiceId },
      throwOnError: true,
    },
  );
  return data;
};

export const getUpgradeBlockedMessage = (
  reason: string | null | undefined,
): string | null => {
  switch (reason) {
    case "already_on_highest_plan":
      return "Você já está no plano mais alto disponível.";
    case "agency_subaccount":
      return "Contate o administrador da sua agência para alterar o plano.";
    case "no_active_subscription":
      return "Você não possui uma assinatura ativa.";
    case "suspended_subscription":
      return "Sua assinatura está suspensa. Contate o suporte para regularizar.";
    default:
      return "Não foi possível alterar o plano no momento.";
  }
};
